module.exports = __webpack_public_path__ + "static/media/IMG-2.24cdc5f6.jpg";